import { FaUser } from 'react-icons/fa';
import { RiLockPasswordFill } from 'react-icons/ri';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { Button, Form } from 'react-bootstrap';
import { useContext, useState } from 'react';
import { GlobalContext } from '../Context/globalContext';
import { toast } from 'react-toastify';
import { LoginApi } from '../Services/userServices';
import { useNavigate } from 'react-router-dom';

export const Login = () => {

    const globalContext = useContext(GlobalContext);
    const [payload, setPayload] = useState({ email: '', password: '', showPass: false });
    const navigate = useNavigate();

    const onSubmit = (e) => {
        e.preventDefault();
        toast.dismiss();
        var re = /^[a-zA-Z0-9._%+-]+@[a-z0-9]+\.[a-z]{2,10}(\.[a-z]{2,10})?(\.[a-z]{2,10})?(\.[a-z]{2,10})?(\.[a-z]{2,10})?$/;
        if (payload.email.trim() === '') {
            toast.error('Please enter email.');
            return false
        } else if (!re.test(payload.email)) {
            toast.error('Please enter valid email.');
            return false
        } else if (payload.password.trim() === '') {
            toast.error('Please enter password.');
            return false
        } else {
            var params = {
                'email': payload.email,
                'password': payload.password
            }
            globalContext.setLoader(true);
            LoginApi(params).then(res => {
                globalContext.setLoggedIn(true);
                sessionStorage.setItem('token', res.data.data.token);
                sessionStorage.setItem('email', res.data.data.email);
                globalContext.setLoader(false);
                setTimeout(() => { toast.success('Logged In Successfully.'); }, 500);
                navigate('/users?page=1');
            }).catch(err => {
                globalContext.setLoader(false);
                toast.error(err.response.data.message)
            })
        }
    }


    return (
        <section className="w3l-workinghny-form">
            <div className="workinghny-form-grid">
                <div className="wrapper">
                    <div className="workinghny-block-grid">
                        <div className="workinghny-left-img align-end">
                            <img src={require('../Assets/img/2.png')} className="img-responsive" alt="img" />
                        </div>
                        <div className="form-right-inf">
                            <h1>LOGIN</h1>
                            <div className="login-form-content">
                                <Form className="signin-form">
                                    <Form.Group className="one-frm" controlId="exampleForm.ControlInput1">
                                        <Form.Label className='text-left'>Email</Form.Label>
                                        <div className='login-email position-relative'>
                                            <Form.Control type="email" placeholder="Enter email" value={payload.email} onChange={(e) => setPayload({ ...payload, email: e.target.value })} onKeyDown={(e) => {
                                                if (e.key == "Enter") {
                                                    onSubmit(e)
                                                }
                                            }} />
                                            <FaUser />
                                        </div>
                                    </Form.Group>
                                    <Form.Group className="one-frm" controlId="exampleForm.ControlPassword1">
                                        <Form.Label className='text-left'>Password</Form.Label>
                                        <div className='login-email position-relative'>
                                            <Form.Control type={payload.showPass ? "text" : "password"} placeholder="Enter password" value={payload.password} onChange={(e) => setPayload({ ...payload, password: e.target.value })} onKeyDown={(e) => {
                                                if (e.key == "Enter") {
                                                    onSubmit(e)
                                                }
                                            }} />
                                            <RiLockPasswordFill />
                                            <a className='eye-btn' onClick={() => setPayload({ ...payload, showPass: !payload.showPass })}>{payload.showPass ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}</a>
                                        </div>
                                    </Form.Group>
                                    <Button className="btn btn-style mt-3" onClick={(e) => onSubmit(e)}>Login</Button>
                                    <p className="already"><a style={{ cursor: "pointer" }}>Forget Password?</a></p>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}